import { Component, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService, Theme } from '../../services/theme.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-theme-switcher',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="dropdown dropdown-end">
      <div tabindex="0" role="button" class="btn btn-ghost btn-circle">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z"></path>
        </svg>
      </div>
      <ul tabindex="0" class="dropdown-content z-[1] menu p-2 shadow bg-white rounded-box w-52">
        @for (theme of availableThemes; track theme.name) {
          <li>
            <button 
              (click)="setTheme(theme.name)"
              [class.active]="currentTheme === theme.name"
              class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full" 
                    [class]="theme.isDark ? 'bg-base-content' : 'bg-primary'"></span>
              {{ theme.displayName }}
              @if (currentTheme === theme.name) {
                <svg class="w-4 h-4 ml-auto" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                </svg>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
  `]
})
export class ThemeSwitcherComponent implements OnDestroy {
  private themeService = inject(ThemeService);
  private destroy$ = new Subject<void>();
  
  public availableThemes = this.themeService.availableThemes;
  public currentTheme = this.themeService.getCurrentTheme();

  constructor() {
    // Subscribe to theme changes
    this.themeService.currentTheme$
      .pipe(takeUntil(this.destroy$))
      .subscribe(theme => {
        this.currentTheme = theme;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public setTheme(themeName: string): void {
    this.themeService.setTheme(themeName);
  }
} 